import './App.css';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import { AuthProvider } from './context/AuthContext';
import { SideBarProvider } from './context/SidebarContext';

function App() {
  return (
    <AuthProvider>
      <SideBarProvider>
        <RouterProvider router={router} />
      </SideBarProvider>
    </AuthProvider>
  );
}

export default App;
